<template>
  <a-spin :spinning="confirmLoading">
    <a-tabs defaultActiveKey="1" type="card" @tabClick="onTabClick">
      <a-tab-pane tab="当前版本" key="1">
        <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
<!--          <a-col :span="24">
            <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              &lt;!&ndash;表单只读，详情&ndash;&gt;
              <j-search-select-tag v-if="formDisabled" type="list" v-decorator="['projId', validatorRules.project]"
                                   :trigger-change="true" dict="proj_project,name,id" :disabled="formDisabled"
                                   placeholder="请选择项目"/>
              &lt;!&ndash;表单新增或编辑&ndash;&gt;
              <j-search-select-tag v-else type="list" v-decorator="['projId', validatorRules.project]"
                                   :trigger-change="true" :dictOptions="projectOptions"
                                   placeholder="请选择项目"/>
            </a-form-item>
          </a-col>-->
          <a-col :span="24" v-if="isEdit">
            <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--表单只读，详情-->
              <j-search-select-tag v-if="formDisabled" type="list" v-decorator="['projId', validatorRules.project]"
                                   :trigger-change="true" dict="proj_project,name,id" :async="true" :disabled="formDisabled"
                                   placeholder="请选择项目"/>
            </a-form-item>
          </a-col>
<!--          <a-col :span="24" v-else> &lt;!&ndash;新增情况,过滤掉已经提交的&ndash;&gt;
            <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              &lt;!&ndash;表单新增或编辑&ndash;&gt;
              <j-search-select-tag v-else type="list" v-decorator="['projId', validatorRules.project]"
                                   :trigger-change="true" :dictOptions="projectOptions"
                                   placeholder="请选择项目"/>
            </a-form-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-item label="合同名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['agreementName', validatorRules.agreementName]" placeholder="请输入合同名称"></a-input>
            </a-form-item>
          </a-col>
          
          <a-col :span="24">
            <a-form-item label="保险公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-decorator="['insurer', validatorRules.insurer]"
                :trigger-change="true"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="保单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['policy', validatorRules.policy]" placeholder="请输入保单号"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="合同起期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择合同起期" v-decorator="['agreementStartTime', validatorRules.agreementStartTime]" :trigger-change="true" style="width: 100%" @change="handleStartDateChange"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="合同止期" :labelCol="labelCol" :wrapperCol="wrapperCol">  <!--validatorRules.agreementEndTime-->
              <j-date class="end-date-of-agreement" placeholder="请选择合同止期" v-decorator="['agreementEndTime', {}]" :trigger-change="true" @change="handleEndDateChange" style="width: 80%; margin-right:30px;"/>
              <a-checkbox @change="handleEndLessChange" :checked="isEndLess">长期</a-checkbox>
            </a-form-item>
          </a-col>
          
          <!-- <a-col :span="24">
            <a-form-item label="保司联系人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['insurerContact', validatorRules.insurerContact]" placeholder="请输入保司联系人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保司联系人电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['insurerContactNumber', validatorRules.insurerContactNumber]" placeholder="请输入保司联系人电话"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="客户联系人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['customerContact', validatorRules.customerContact]" placeholder="请输入客户联系人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="客户联系人电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['customerContactNumber', validatorRules.customerContactNumber]" placeholder="请输入客户联系人电话"></a-input>
            </a-form-item>
          </a-col> -->
          <a-col :span="24">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['remarks',validatorRules.remarks]" :rows="4"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="合同附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-upload v-decorator="['agreementFile']" :trigger-change="true"  bizPath="customer-agreement" :disabled="formDisabled" @change="handleFileChange"></j-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
      </a-tab-pane>
      <a-tab-pane v-for="version in tabs" :tab="version" :key="version">
        <j-form-container :disabled="formDisabled">
          <a-form :form="form" slot="detail">
            <a-row>
              <a-col :span="24">
                <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <!--表单只读，详情-->
                  <j-search-select-tag type="list" v-model="tabModel.projId"
                                       :trigger-change="true" dict="proj_project,name,id" :async="true" :disabled="formDisabled"
                                       placeholder="请选择项目" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="合同名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="tabModel.agreementName" placeholder="请输入合同名称" disabled></a-input>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="保险公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-search-select-tag
                    placeholder="请选择保险公司"
                    v-model="tabModel.insurer"
                    :trigger-change="true"
                    dict="biz_insurance_company,name,code"
                    disabled>
                  </j-search-select-tag>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="保单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="tabModel.policy" placeholder="请输入保单号" disabled></a-input>
                </a-form-item>
              </a-col>

              <a-col :span="24">
                <a-form-item label="合同起期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-date placeholder="请选择合同起期" v-model="tabModel.agreementStartTime" :trigger-change="true" disabled style="width: 100%"/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="合同止期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-date class="end-date-of-agreement" placeholder="请选择合同止期" v-model="tabModel.agreementEndTime" disabled style="width: 80%; margin-right:30px;"/>
                  <a-checkbox @change="handleEndLessChange" :checked="isEndLess">长期</a-checkbox>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea v-model="tabModel.remarks" :rows="4" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="合同附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-upload v-model="tabModel.agreementFile"  bizPath="customer-agreement" :disabled="formDisabled"  disabled></j-upload>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </j-form-container>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import { httpAction, postAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JUpload from '@/components/jeecg/JUpload'
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
  import JEditor from '@/components/jeecg/JEditor'
  import {dateOfOneYearLater} from "@/utils/util"
  import ProjectStatus from '../../ProjectStatus'

  export default {
    name: 'BizAgreementinfoForm',
    components: {
      JFormContainer,
      JDate,
      JUpload,
      JSelectDepart,
      JSearchSelectTag,
      JDictSelectTag,
      JEditor,
    },
    props: {
      //表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        projectOptions: [],
        tabs: [],
        tabModel: {},
        form: this.$form.createForm(this),
        isEdit: false,
        startDisabled: false,
        endDisabled: false,
        isEndLess: false, //合同是否长期 默认否
        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          project: {
            rules: [
              { required: true, message: '请选择项目!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          insurer:{
            rules: [
              { required: true, message: '请选择保险公司!'},
            ]
          },

          policy:{
            rules: [
              { max: 50, message: '保单号长度不能超过50个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },

          agreementName: {
            rules: [
              { required: true, message: '请输入合同名称!'},
              { max: 50, message: '合同名称不能超过50个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },

          agreementStartTime: {
            rules: [
              { required: true, message: '请输入合同起期!'},
            ]
          },
          remarks:{
            rules:[
              { max: 255, message: '备注长度不能超过255个字符!'},
            ]
          },
        },
        url: {
          add: "/project/customerAgreement/add",
          edit: "/project/customerAgreement/edit",
          queryById: "/project/customerAgreement/queryById",
          updateFilePathImmediate: "/project/customerAgreement/updateFilePathImmediate",
          hisData:"/project/customerAgreement/hisData",
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
      this.projectStatus = ProjectStatus
      this.loadProjectOptions()
    },
    methods: {
      loadProjectOptions() {
        getAction("/project/baseInfo/optionList", {status: this.projectStatus.SIGN_WAIT}).then(res => {
          if (res.success) {
            this.projectOptions = res.result || []
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      onTabClick(key) {
        if(key == 1) {return;}
        let url = this.url.hisData;
        let tempModel = this.tabModel;
        let param = {version: key,projId: this.tabModel.projId};
        postAction(url,param).then((res)=>{
          if(res.success){
            if(res.result){
              Object.keys(res.result).forEach(key => {
                tempModel[key] = res.result[key]
              })
            } else {
              callback('未找到该项目');
            }
          }else{
            callback(res.message);
          }
        })
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        
        if(this.model.id){
          this.isEdit = true;
          if(this.model.agreementEndTime == '2099-12-31 23:59:59'){ // 此日期约定为长期
            this.isEndLess = true;
            this.model.agreementEndTime = null; // 置空值
          } else {
            this.isEndLess = false;
          }
        }else{ // 新增
          this.isEdit = false;
          this.model.status = '0'; // 初始为未提交状态
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'agreementCode','projId','agreementType','customer',
          'agreementName','policy','agreementStartTime','agreementEndTime','agreementFile','insurer',
          'remarks'))
        })
        let vs = this.model.versions
        if(vs) {
          this.tabModel = Object.assign({}, record);
          this.tabs = vs.split(',');
        } else {
          this.tabs = []
        }
      },

      submitForm () {
        const that = this;

        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = Object.assign(this.model, values);

            formData.agreementStartTime = formData.agreementStartTime + " 00:00:00";
            this.trimFormData(formData);
            // 判断合同止期
            if(!that.isEndLess) {
              if (formData.agreementEndTime == null || formData.agreementEndTime.trim() == '') {
                that.$message.warn("必须设置合同止期");
                that.confirmLoading = false;
                return;
              }
              // 合同止期设置为当天的最大时间,不存在才添加
              if(formData.agreementEndTime.indexOf('23:59:59') <0){
                formData.agreementEndTime = formData.agreementEndTime +' 23:59:59'
              }
            }else {
              formData.agreementEndTime = '2099-12-31 23:59:59'
            }

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success("保存成功");
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      trimFormData(formData){
        formData.agreementName = formData.agreementName ? formData.agreementName.trim() : '';
        formData.policy = formData.policy ? formData.policy.trim() : '';
        // formData.insurerContact = formData.insurerContact ? formData.insurerContact.trim() : '';
        // formData.insurerContactNumber = formData.insurerContactNumber ? formData.insurerContactNumber.trim() : '';
        // formData.customerContact = formData.customerContact ? formData.customerContact.trim() : '';
        // formData.customerContactNumber = formData.customerContactNumber ? formData.customerContactNumber.trim() : '';
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(this.model,'agreementCode','projId','agreementType','customer',
          'agreementName','policy','agreementStartTime','agreementEndTime','agreementFile','insurer',
          'remarks')) // ,'customerContact','customerContactNumber','insurerContact','insurerContactNumber'
      },
      
      //计算一年后的日期赋值给结束日期控件，默认一年合同
      handleStartDateChange(value){
        if(value != null && value.trim() != ''){
          let nextDate = dateOfOneYearLater(value)
          this.form.setFieldsValue({agreementEndTime: nextDate})
          this.isEndLess = false
        }
      },
      handleEndDateChange(value){
        if(value != null && value.trim() != ''){
          this.isEndLess = false
          //this.form.setFieldsValue({isEndLess: false})
        }
      },

      handleEndLessChange(event){
        if(event && event.target.checked){
          this.isEndLess = true;
          //this.form.setFieldsValue({isEndLess: true})
          this.model.agreementEndTime = null;
          this.form.setFieldsValue({agreementEndTime: null})
        }
      },

      // 文件列表改变后及时更新数据库（编辑状态下）
      handleFileChange(filePath){
        // 编辑状态下变化，存在单据id
        let id = this.model.id
        if(id){
          postAction(this.url.updateFilePathImmediate, {id: id, filePath: filePath}).then(res =>{
            if(res.success){
            } else {
              this.$message.warn("附件更新时出现错误:" + res.message)
            }
          })
        }
      },

    }
  }
</script>

<style >
  /* 添加必选项标识 加空格防止污染其他地方*/
  [title=" 合同止期"]::before {
    display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
  }

</style>